import { PortraitMenu } from "../../../library-js/dom-actions/PortraitMenu";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { DOMOrientation } from "../../../library-js/dom/DOMOrientation";
import { CarouselElementType } from "./CarouselElementType";
import { CarouselElement } from "./CarouselElement";
import { CarouselSelect } from "./CarouselSelect";

export class CarouselSection
{
  _select:CarouselSelect;
  _element:Element;
  _landscapeElement:CarouselElement;
  _potraitElement:CarouselElement;

  constructor( select:CarouselSelect, element:Element )
  {
    this._select = select;
    this._element = element;
    this._landscapeElement = CarouselElementType.create( select, ElementType.landscapeOnly.query( element ) );
    this._potraitElement = CarouselElementType.create( select, ElementType.portraitOnly.query( element ) );
  }

  getActiveElement()
  {
    if ( DOMOrientation.isLandscape )
    {
      return this._landscapeElement;
    }
    else if ( DOMOrientation.isPortrait )
    {
      return this._potraitElement;
    }
  }

}